document.addEventListener("DOMContentLoaded", function ()
{
    "use strict";

    if (document.wasDiscarded)
    {
        $.ajax({
            url: skyward.global.virtualDir + "SkySys/Log/LogDiscardedTab",
            type: "POST",
            dataType: "JSON",
            success: function () { },
            error: function () { }
        });
    }
});